{
  "appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Neuen Termin buchen"
    },
    "meta": {
      "title": "Termindetails",
      "description": "Alle Infos zum Termin"
    }
  }
}
